module.exports = __webpack_public_path__ + "img/core1.3810e8bc.png";